import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appActions } from '../../../../store/modules/app';
import { pointActions } from '../../../../store/modules/point';
import withModal from '../../../../lib/hoc/withModal';
import GeneratePointValidFailModal from '../../../../views/app/common/modal/GeneratePointValidFailModal';

/**
 *  포인트 발급 유효 체크 실패 모달
 */
class GeneratePointValidFailModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.appToggleModal({
      name: 'generatePointValidFailModal',
      value: false,
    });
  };

  /**
   * 엑셀 일괄 발급 모달 열기
   */
  openExcelBulkGeneratePointModal = () => {
    this.props.toggleModal({
      name: 'excelBulkGeneratePointModal',
      value: true,
    });

    /**
     *  모달 닫기
     */
    this.closeModal();
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <GeneratePointValidFailModal
        isOpen={isOpen}
        data={data}
        openExcelBulkGeneratePointModal={this.openExcelBulkGeneratePointModal}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.generatePointValidFailModal.isOpen,
    data: state.app.generatePointValidFailModal.data,
  };
};

const mapDispatchToProps = {
  appToggleModal: appActions.appToggleModal,
  toggleModal: pointActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(GeneratePointValidFailModalContainer));
